import React from 'react'
import { Text, View } from 'react-native'
import { parseNews } from '@warcarp/api-types'

/** Used by the admin preview and both apps' read-only article view. */
export function NewsBody({ body, color = '#242918', surfaceColor = '#fffdf7', borderColor = '#e1d9c3', accentColor = '#a01818', onOpenLink }: {
  body: string; color?: string; surfaceColor?: string; borderColor?: string; accentColor?: string; onOpenLink?: (href: string) => void
}) {
  const blocks = parseNews(body).filter(block => block.spans.length > 0)
  const rows: ({ kind: 'list'; blocks: typeof blocks } | typeof blocks[number])[] = []
  for (const block of blocks) {
    const last = rows.at(-1)
    if (block.kind === 'bullet' && last?.kind === 'list') last.blocks.push(block)
    else if (block.kind === 'bullet') rows.push({ kind: 'list', blocks: [block] })
    else rows.push(block)
  }
  const renderSpans = (block: typeof blocks[number]) => block.spans.map((span, i) => <Text key={i}
    accessibilityRole={span.href ? 'link' : undefined}
    onPress={span.href && onOpenLink ? () => onOpenLink(span.href!) : undefined}
    style={{ color: span.href ? accentColor : color,
      textDecorationLine: span.href ? 'underline' : undefined,
      fontWeight: span.emphasis === 'bold' ? '700' : undefined,
      fontStyle: span.emphasis === 'italic' ? 'italic' : undefined,
    }}>{span.text}</Text>)
  return <View testID="news-body" style={{ backgroundColor: surfaceColor, borderColor, borderWidth: 1, borderRadius: 12, padding: 16 }}>
    <View style={{ gap: 8 }}>
      {rows.map((row, index) => {
        if (row.kind === 'list') return <View key={`list-${index}`} style={{ gap: 3 }}>
          {row.blocks.map((block, itemIndex) => <View key={itemIndex} style={{ flexDirection: 'row', alignItems: 'flex-start', gap: 8, paddingLeft: 2 }}>
            <Text accessibilityElementsHidden style={{ color: accentColor, fontSize: 16, lineHeight: 23 }}>•</Text>
            <Text selectable style={{ flex: 1, color, fontSize: 16, lineHeight: 23 }}>{renderSpans(block)}</Text>
          </View>)}
        </View>
        const block = row
        const heading = block.kind === 'h1' || block.kind === 'h2'
        return <Text key={index} selectable accessibilityRole={heading ? 'header' : undefined}
          style={{ color, fontSize: block.kind === 'h1' ? 22 : block.kind === 'h2' ? 18 : 16,
            lineHeight: block.kind === 'h1' ? 28 : block.kind === 'h2' ? 24 : 23,
            fontWeight: heading ? '700' : '400' }}>
          {renderSpans(block)}
        </Text>
      })}
    </View>
  </View>
}
